import React, { Component } from 'react';
import './NotFound.css';

class NotFound extends Component {
    render() {
        return (
            <div>Not Found</div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js